import React from 'react';

export const CONNECTION_STATUS_TEXT = {
    connected: 'Connected',
    connecting: 'Connecting...',
    disconnected: 'Disconnected',
    error: 'Connection Error',
    idle: 'Not live'
};

/**
 * Resolves the visual tone of the connection dot.
 * The dot stays grey before kick-off and after full-time: there is nothing to
 * stream then, so a red or green light would only add noise.
 */
export const getConnectionTone = (socketStatus, { isLiveMatch = true } = {}) => {
    if (!isLiveMatch) return 'idle';
    if (socketStatus === 'connected') return 'ok';
    if (socketStatus === 'connecting') return 'warning';
    if (socketStatus === 'error') return 'error';
    return 'warning';
};

/**
 * Small pulsing connection dot rendered in the match header. Replaces the old
 * full-width light-theme "Connected" banner.
 */
function MatchConnectionStatus({ status, isLiveMatch = true }) {
    const tone = getConnectionTone(status, { isLiveMatch });
    const statusText = isLiveMatch
        ? (CONNECTION_STATUS_TEXT[status] || CONNECTION_STATUS_TEXT.disconnected)
        : CONNECTION_STATUS_TEXT.idle;

    return (
        <span
            className={`mx-conn mx-conn--${tone}`}
            data-testid="match-connection-status"
            data-tone={tone}
            title={statusText}
        >
            <span className="mx-conn__dot" aria-hidden="true" />
            <span className="mx-conn__label" role="status">{statusText}</span>
        </span>
    );
}

export default MatchConnectionStatus;
